/** Escape a string for use inside a GraphQL string literal (handles " and \ in HTML/content). */
export const escapeQuatations = (s) =>
  String(s).replace(/\\/g, '\\\\').replace(/"/g, '\\"');

export const getHtmlInnerText = (htmlStr) => {
  const div = document.createElement('div');
  div.innerHTML = htmlStr;
  return div.textContent;
};
